module.exports = __webpack_public_path__ + "img/zjswzshdgzc_position_img.3d69101a.png";